import React from 'react';
import { FooterOrigination } from '@honeycomb-npm/honeycomb-react';

const Footer = () => <FooterOrigination fluid />;

export default Footer;
